export enum EnvironmentEnum {
  Enterprise = 'Enterprise',
  BackOffice = 'BackOffice',
}